import { render, staticRenderFns } from "./TableGeneric.vue?vue&type=template&id=708347ea&scoped=true&"
import script from "./TableGeneric.vue?vue&type=script&lang=js&"
export * from "./TableGeneric.vue?vue&type=script&lang=js&"
import style0 from "./TableGeneric.vue?vue&type=style&index=0&id=708347ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708347ea",
  null
  
)

export default component.exports